import React, { useState } from "react";
import { ProfileRejectReview, RegContentWrapper, RegistrationWrapper } from "./Styled";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import { Box, ButtonStyled, ButtonStyledTb, HeadingStyled, HeadingStyledSm, SpanStyled } from "../../../components/styled/Elements";
import { Form } from "react-bootstrap";
import CustomProgressBar, { MultiStepProgressBar } from "./MultiStepProgressBar";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Step4 } from "./Step4";
import { useNavigate } from "react-router-dom";
import { steps } from "../../../components/data/data";
import { useTranslation } from "react-i18next";
import { UnderReviewImg } from "../../../components/styled/AllImages";

const UnderReviewNote = () => {
    const { t } = useTranslation();
    

    return (
        <>
            <RegistrationWrapper>
                <AuthHeader headerBg={true} />
                <Box className="registartionHeader px-4">
                    <HeadingStyled size="24px">
                        {t("ProfileUnderReview")}
                    </HeadingStyled>
                </Box>
                <RegContentWrapper className="px-4">
                    <Box className="RegContentContainer d-flex flex-column">
                        <ProfileRejectReview>
                            <Box className="RegContentPRR">
                                <img src={UnderReviewImg} alt="Under Review" />
                                <Box className="prrContentContainer">
                                    <HeadingStyled size="24px" color="var(--darkGrey)">
                                    {t("ProfileUnderReview")}
                                    </HeadingStyled>
                                    <SpanStyled color="var(--lightGrey)">
                                        {t("Yourprofilesubmitted")}
                                    </SpanStyled>
                                </Box>
                            </Box>
                        </ProfileRejectReview>
                    </Box>
                </RegContentWrapper>
            </RegistrationWrapper>
            
        </>
    );
}

export default UnderReviewNote;

